// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ValpaintSection-module--imageContainer--3B6gp","largeImage":"ValpaintSection-module--largeImage--1WBrl","logo":"ValpaintSection-module--logo--28HBZ"};